import { joinParts } from './utils'

export const purchase = {
  form: () => joinParts('purchase', 'form'),
}
